<template>
  <div class="l-coin">
    <img class="l-img" src="./images/l-coin.png" alt="COIN" />{{
      lilyCoin
    }}
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapGetters } = createNamespacedHelpers("user");

export default {
  name: "l-coin",
  props: {
    lilyCoin: {
      default:0,
      type:Number,
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>

<style lang="stylus" scoped>
@import './index.styl';
</style>
